module.exports = __webpack_public_path__ + "static/media/cyklo.82044933.png";